module.exports = __webpack_public_path__ + "static/people_pop12-a05cdda072e4417a9c807b4d3bf4a111.png";